import { useMediaQuery } from "@mui/material";

/**
 * Compact layout for laptop displays ≤13.5" (diagonal).
 * Maps to typical logical viewport widths on those machines (≈1280–1710px),
 * e.g. 13.5" Surface (~1504px) and 13.6" MacBook Air up to "More Space" (1710px).
 */
export const COMPACT_SCREEN_MAX_WIDTH_PX = 1710;

export function useCompactScreen() {
  return useMediaQuery(`(max-width: ${COMPACT_SCREEN_MAX_WIDTH_PX}px)`);
}
